import {
  createBrowserRouter,
  Route,
  RouterProvider,
  Routes,
} from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Suspense, lazy, useContext, useEffect, useState } from 'react';

import "./index.css";

import Context from './Context';

import ScrollToTop from "./Helpers/ScrollToTop";
import Metas from "./Helpers/Metas";
import SEOHelper from "./Helpers/SEOHelper";
import APICall from "./APIConnect";
import Cookies from "./Components/DefaultPack/Cookies";
import GTManager from "./Components/DefaultPack/GTManager";
import MultiLanguage, { getLangFromUrl } from "./Components/DefaultPack/MultiLanguage";
import Header from "./Parts/Header";
import Footer from "./Parts/Footer";
import Assembly from "./Pages/Assembly";
import Consorcio from "./Components/Consorcio";

const Obrigado = lazy(() => import('./Pages/Obrigado'));
const Generic = lazy(() => import('./Pages/Generic'));
const Post = lazy(() => import('./Pages/Post'));
const Servico = lazy(() => import('./Pages/Servico'));

const router = createBrowserRouter([
  {
    path: "*",
    element: <Main />,
  },
],
  {
    basename: getLangFromUrl()
  });

function App() {
  const [textos, setTextos] = useState<any>();
  const [imagens, setImagens] = useState<any>();
  const [configuracoes, setConfiguracoes] = useState<any>();
  const [resumo, setResumo] = useState<any>();
  const value = { textos, imagens, configuracoes, resumo };

  useEffect(() => {
    APICall("GET", "/configuracoes").then(response => {
      if (response.data.status !== 200) {
        window.alert("Ocorreu um erro ao solicitar os dados do site.");
      } else {
        let configuracoes: any | undefined = response.data.success?.configuracoes;
        setConfiguracoes(configuracoes);

        let imagens: any | undefined = response.data.success?.imagens;
        setImagens(imagens);

        let textos: any | undefined = response.data.success?.textos;
        setTextos(textos);

        let resumo: any | undefined = response.data.success;
        setResumo(resumo);
      }
    });
  }, []);

  return (
    <Context.Provider value={value}>
      <HelmetProvider>
        {configuracoes ?
          <div className="App">
            <MultiLanguage />
            <Suspense fallback={<div className="suspense"></div>}>
              <RouterProvider router={router} />
            </Suspense>
          </div>
          : <></>
        }
      </HelmetProvider>
    </Context.Provider>
  );
}

function Main() {
  const { configuracoes, textos } = useContext(Context);
  const [withCache, setCache] = useState<boolean>(false);

  useEffect(() => {
    if (configuracoes && configuracoes.withCache === true) {
      setCache(true)
    } else {
      setCache(false);
    }
  }, [configuracoes]);

  return (
    <>
      <Metas />
      <ScrollToTop />
      <SEOHelper key={`seo_helper_updater_${withCache ? "cache" : "no_cache"}`} withCache={withCache} />
      <Header />
      <Routes>
        <Route path={`/consorcio`} element={<Consorcio />} />
        <Route path={`/servicos/:slug`} element={<Servico />} />
        <Route path={`/obrigado/contato`} element={<Obrigado />} />
        <Route path={`/obrigado/newsletter`} element={<Obrigado />} />
        <Route path={`/obrigado/curriculo`} element={<Obrigado />} />
        <Route path={`/termos-de-uso`} element={<Generic title="Termos de Uso" content={textos.termos_de_uso} />} />
        <Route path={`/politica-de-privacidade`} element={<Generic title="Política de Privacidade" content={textos.politica_de_privacidade} />} />
        <Route path={"*"} element={<Assembly />} />
      </Routes>
      <Footer />
      <Cookies />
      <GTManager />
    </>
  )
}

export default App;
